var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOtpLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 79.999,
    viewBox: "0 0 80 79.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;fill:url(#a);}.b{fill:#fff;}.c{fill:none;stroke:#fff;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.747,
    x2: -0.013,
    y2: 0.139,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.149
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 -279)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.285,
    cy: 39.285,
    r: 39.285,
    transform: "translate(113.713 279.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40,80A40.01,40.01,0,0,1,24.43,3.143,40.01,40.01,0,0,1,55.569,76.856,39.751,39.751,0,0,1,40,80Zm.234-78.682H40A38.725,38.725,0,0,0,1.318,40c0,17.888,16.9,38.681,38.681,38.681A38.725,38.725,0,0,0,78.681,40c0-10-4.376-19.7-12.322-27.319C58.829,5.459,49.306,1.317,40.234,1.318Z",
    transform: "translate(112.999 279)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.142 300.098)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.287)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.464,2H31.25l4.464,6.31L31.25,14.054H4.464L0,8.334Z",
    transform: "translate(0 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.756,13.66l-.254-.88-2.141.6.108-2.034h-.982l.108,2.034-2.155-.6-.24.88,2.127.4-1.281,1.806.808.5,1.117-1.858L14.1,16.373l.794-.5-1.267-1.806Z",
    transform: "translate(-5.756 -7.695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.756,13.66l-.254-.88-2.141.6.108-2.034h-.982l.108,2.034-2.155-.6-.24.88,2.127.4-1.281,1.806.808.5,1.117-1.858L14.1,16.373l.794-.5-1.267-1.806Z",
    transform: "translate(1.387 -7.695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.756,13.66l-.254-.88-2.141.6.108-2.034h-.982l.108,2.034-2.155-.6-.24.88,2.127.4-1.281,1.806.808.5,1.117-1.858L14.1,16.373l.794-.5-1.267-1.806Z",
    transform: "translate(8.53 -7.695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.756,13.66l-.254-.88-2.141.6.108-2.034h-.982l.108,2.034-2.155-.6-.24.88,2.127.4-1.281,1.806.808.5,1.117-1.858L14.1,16.373l.794-.5-1.267-1.806Z",
    transform: "translate(15.673 -7.695)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.1,31.328v11.92H35.957V31.331ZM28.758,41.788H25.4l.647-3.336a1.73,1.73,0,1,1,1.959,0Z",
    transform: "translate(-9.127 -19.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.26,0l2.823,4.215-2.1,6.8-7.072-.381L0,6.484",
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 19.646, 15.958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtpLocked);
export default __webpack_public_path__ + "static/media/ic_otp_locked.12ffc9c466d6351249168506337d96e7.svg";
export { ForwardRef as ReactComponent };